import { Component, inject, signal } from '@angular/core';
import { FeatureCardComponent } from '../../components/feature-card/feature-card.component';
import { featureCards } from './content';
import { CardComponent } from '../../components/card/card.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { GeneralFeedbackComponent } from '../../components/feedback-fab/components/general-feedback/general-feedback.component';
import { AuthService } from '../../state/auth/auth.service';

@Component({
  selector: 'app-home-page',
  imports: [FeatureCardComponent, CardComponent, WelcomeComponent, GeneralFeedbackComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css',
})
export class HomePageComponent {
  public featureCards = signal([...featureCards]);

  constructor() {
    const authService = inject(AuthService);

    authService.user.then((user) => {
      if (user && user.permissions.includes('featureflags:read')) {
        const cards = this.featureCards();
        const wom = cards.find((card) => card.title === 'Wild Oats Mapping');
        if (!wom) {
          const wildOatsMapping = {
            title: $localize`Wild Oats Mapping`,
            content: $localize`Detect wild oats during harvest - and use the data for targeted weed control.`,
            image: 'images/home_wild_oats_mapping.png',
            action: {
              href: '/wild-oats-mapping',
              label: $localize`Go to Wild oats mapping`,
            },
            ribbon: 'idea' as const,
          };
          const insertAt = Math.max(cards.length - 1, 0);
          this.featureCards.set([...cards.slice(0, insertAt), wildOatsMapping, ...cards.slice(insertAt)]);
        }
      }
    });
  }
}
